import { ConfiguracoesMisc } from "./configuracoesMisc";
import { ConfiguracoesSite } from "./configuracoesSite";

export class Configuracoes {
  public static NAME;
  public static API;
  public static API2;
  public static IMAGELOGO;
  public static API_BANNERS;
  public static IMAGEBACKGROUND;
  public static API_GATEWAY_PAGAMENTO_URL;
  public static API_IMAGENS;
  public static API_IMAGENS_PRODUTOS;
  public static API_BRANCH;
  public static layout;
  // public static gtagId;
  public static SITE: ConfiguracoesSite;
  public static MISC: ConfiguracoesMisc = {};
  public static modoVisualizacaoCatalogo;
  public static modoVisualizacaoPageProduto: number;
  public static descontoPorItem: number;
  public static apiKeyGatewayPgto: string;
  public static mostraPrecoMinimoVenda: boolean;
  public static mostraCarrinho: boolean;
  public static mostraCarrinhoCatalogo: boolean;
  public static exibeVisualizacaoCatalogo: number[];
  public static exibeModalProdutoCatalogo: boolean;
  public static filtroColapsado: boolean;
  public static menuDinamico;
  public static layoutMenu;
  public static descricao_estoque_indisponivel;
  public static prod: boolean;
  public static cypher: boolean;

  //https://themestr.app/theme
  //http://colormind.io/bootstrap/
  public static themes: Array<any> = [
    { id: "blush", color: "#b94b70" },
    { id: "chambray", color: "#396387" },
    { id: "matterhorn", color: "#4C3C42" },
    { id: "tobaccobrown", color: "#735641" },
    { id: "stilleto", color: "#97353A" },
    { id: "bazaar", color: "#917A81" },
    { id: "scarlate", color: "#8b0d13" },
    { id: "william", color: "#3C6167" },
    { id: "bastille", color: "#292530" },
  ];

  public static patchAppConfig(c) {
    this.menuDinamico = c.menuDinamico;
    this.layoutMenu = c.layoutMenu;
    this.NAME = c.NAME;
    this.filtroColapsado = c.filtroColapsado;
    this.API = c.API;
    this.API_BANNERS = c.API_BANNERS ? c.API_BANNERS : null;
    this.API2 = c.API2;
    this.IMAGELOGO = c.IMAGELOGO;
    this.IMAGEBACKGROUND = c.IMAGEBACKGROUND;
    this.API_IMAGENS = c.API_IMAGENS;
    this.API_IMAGENS_PRODUTOS = c.API_IMAGENS_PRODUTOS;
    this.API_BRANCH = c.API_BRANCH;
    this.layout = c.Layout;
    this.modoVisualizacaoCatalogo = c.modoVisualizacaoCatalogo
      ? c.modoVisualizacaoCatalogo
      : "4x4";
    this.modoVisualizacaoPageProduto = c.modoVisualizacaoPageProduto
      ? c.modoVisualizacaoPageProduto
      : 1;
    this.descontoPorItem = c.descontoPorItem ? c.descontoPorItem : 0;
    this.apiKeyGatewayPgto = c.APIKEY_GATEWAYPGTO;

    // if (c.gtagId) {
    //   this.gtagId = c.gtagId;
    // }
    if (c.miscCadCliNoAutEndereco) {
      this.MISC.miscCadCliNoAutEndereco = c.miscCadCliNoAutEndereco;
    }
    if (c.mostraCarrinhoCatalogo) {
      this.mostraCarrinhoCatalogo = c.mostraCarrinhoCatalogo;
    }
    if (c.registroLogin) {
      this.MISC.registroLogin = c.registroLogin;
    }
    if (c.prod) {
      this.prod = c.prod;
    }
    if (c.cypher) {
      this.cypher = c.cypher;
    }
    if (c.menuDinamico) {
      this.MISC.menuDinamico = c.menuDinamico;
    }
    if (c.footer) {
      this.MISC.fotterProps = c.footer;
    }
    if (c.mostraPrecoMinimoVenda) {
      this.mostraPrecoMinimoVenda = c.mostraPrecoMinimoVenda;
    }
    if (c.mostraCarrinho !== null) {
      this.mostraCarrinho = c.mostraCarrinho;
    }
    if (c.exibeVisualizacaoCatalogo) {
      this.exibeVisualizacaoCatalogo = c.exibeVisualizacaoCatalogo;
    }
    if (c.exibeModalProdutoCatalogo) {
      this.exibeModalProdutoCatalogo = c.exibeModalProdutoCatalogo;
    }
    if (c.descricao_estoque_indisponivel) {
      this.MISC.descricao_estoque_indisponivel =
        c.descricao_estoque_indisponivel;
    }
    if (c.API_GATEWAY_PAGAMENTO_URL) {
      this.API_GATEWAY_PAGAMENTO_URL = c.API_GATEWAY_PAGAMENTO_URL;
    }
  }
}
